export default "__VITE_ASSET__ByjdKpCF__"